const classes = {
  containerPadding: {
    padding: '18px',
    flex: 1,

  },
};

export default classes;
